var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientPortfolioCard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 701,
    height: 494,
    viewBox: "0 0 701 494",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3091 190.59V100.122C173.962 70.8768 226.722 87.9364 235.27 100.122C332.723 178.404 349.072 244.747 345.064 268.133C339.855 285.981 310.603 307.644 235.27 251.517C159.937 195.39 67.9072 187.513 31.3091 190.59Z",
    fill: "url(#paint0_linear_762_840)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M636.45 375.275V465.743C493.798 494.988 441.038 477.928 432.489 465.743C335.037 387.461 318.688 321.118 322.695 297.731C327.904 279.884 357.156 258.221 432.489 314.348C507.823 370.475 599.852 378.352 636.45 375.275Z",
    fill: "url(#paint1_linear_762_840)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_762_840",
    x1: 306.196,
    y1: 229.731,
    x2: 40.6442,
    y2: 167.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DED1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_762_840",
    x1: 361.564,
    y1: 336.134,
    x2: 627.115,
    y2: 398.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DED1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientPortfolioCard1);
export default __webpack_public_path__ + "static/media/gradient-portfolio-card1.17e18e78106a600eff191123aaccf051.svg";
export { ForwardRef as ReactComponent };